/* Made by Minga product page helpers: filled gallery grid + mobile sticky add-to-cart */
(function () {
  function initGallery(root) {
    var collage = root.querySelector('.product-media-collage');
    if (!collage) return;
    function layout() {
      var items = Array.prototype.slice.call(collage.querySelectorAll('.product-media-collage__item'));
      var vis = items.filter(function (el) { return !el.hidden && getComputedStyle(el).display !== 'none'; });
      var wide = [];
      if (vis.length) {
        wide.push(vis[0]);
        if (vis.length > 1 && (vis.length - 1) % 2 === 1) wide.push(vis[vis.length - 1]);
      }
      items.forEach(function (el) {
        var want = wide.indexOf(el) > -1;
        if (el.classList.contains('mp-wide') !== want) el.classList.toggle('mp-wide', want);
      });
    }
    layout();
    new MutationObserver(layout).observe(collage, { attributes: true, subtree: true, attributeFilter: ['style', 'hidden', 'class'], childList: true });
    window.addEventListener('load', layout);
  }

  function initBar(root) {
    var atc = root.querySelector('.add-to-cart');
    if (!atc || document.querySelector('.mp-bar')) return;
    var title = root.querySelector('.product-title');
    var bar = document.createElement('div');
    bar.className = 'mp-bar';
    bar.innerHTML = '<div class="mp-bar__n"></div><button type="button"></button>';
    document.body.appendChild(bar);
    var n = bar.querySelector('.mp-bar__n'), btn = bar.querySelector('button');
    function sync() {
      var price = root.querySelector('.price__current');
      var opts = Array.prototype.map.call(root.querySelectorAll('variant-picker .opt-btn:checked'), function (i) { return i.value; });
      var sel = root.querySelector('variant-picker select');
      if (!opts.length && sel && sel.selectedIndex > -1) opts = [sel.options[sel.selectedIndex].text.trim()];
      n.innerHTML = '';
      n.appendChild(document.createTextNode((title ? title.textContent.trim() : '') + (price ? ' · ' + price.textContent.trim() : '')));
      if (opts.length) { var s = document.createElement('span'); s.textContent = opts.join(' · '); n.appendChild(s); }
      btn.textContent = atc.textContent.trim();
      btn.disabled = atc.disabled;
    }
    btn.addEventListener('click', function () { if (!atc.disabled) atc.click(); });
    new MutationObserver(sync).observe(atc, { childList: true, characterData: true, subtree: true, attributes: true });
    root.addEventListener('change', function () { setTimeout(sync, 60); });
    function onScroll() {
      var r = atc.getBoundingClientRect();
      bar.classList.toggle('is-on', window.innerWidth < 768 && r.bottom < 0);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    sync(); onScroll();
  }

  function init() {
    document.querySelectorAll('body.template-product product-form.product-info').forEach(function (root) {
      if (root.closest('.quickbuy-container, quick-buy-popup, .js-quickbuy')) return;
      initGallery(root);
      initBar(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
